export const proposalVolume = propostaCargas =>
  propostaCargas.reduce((acc, cur) => acc + Number(cur.propostaCargaPeriodo[0].volumeCarga), 0);
